var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupUploadIcon = function SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_setting_alertsetting_managesymbolfiles_popup_upload_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M643 317h64v48h-64z",
    "data-name": "\\u77E9\\u5F62 588"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_setting_alertsetting_managesymbolfiles_popup_upload_icon_svg__a)",
    transform: "translate(-643 -317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6669fe",
    d: "M666.303 344.752a18.468 18.468 0 0 0 36.936 0 18.468 18.468 0 0 0-36.936 0",
    "data-name": "\\u8DEF\\u5F84 511",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M693.8 361.541h-6.51a2.015 2.015 0 0 1 0-4.031h6.51a9.17 9.17 0 0 0 0-18.341h-.336a2.014 2.014 0 0 1-2.015-1.982 16.44 16.44 0 0 0-32.873-.034 2.014 2.014 0 0 1-2.015 1.982h-.331a9.187 9.187 0 1 0 0 18.374h5.943a2.015 2.015 0 0 1 0 4.031h-5.943a13.214 13.214 0 0 1-1.578-26.335 20.477 20.477 0 0 1 40.7 0 13.214 13.214 0 0 1-1.552 26.336",
    "data-name": "\\u8DEF\\u5F84 512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "m683.596 348.681-7.152-7.085a2.006 2.006 0 0 0-2.821 0l-7.156 7.085a2.018 2.018 0 0 0 2.854 2.854l3.732-3.693v15.144a2.015 2.015 0 1 0 4.029 0v-15.144l3.727 3.66a2.047 2.047 0 0 0 2.854 0 2.04 2.04 0 0 0-.067-2.821",
    "data-name": "\\u8DEF\\u5F84 513"
  }))));
};
export default SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupUploadIcon;